export default class OrderHistoryModel {}
